/** مسیرهایی که بدون سازمان فعال قابل دسترسی‌اند */
const TENANT_EXEMPT_PREFIXES = [
  '/dashboard',
  '/organizations',
  '/users',
  '/profile',
  '/security',
  '/settings',
  '/billing', // سوپرادمین: مالی سطح پلتفرم بدون سازمان فعال
];

/** آیا مسیر به سازمان فعال (tenant) وابسته است؟ */
export function requiresTenantContext(pathname) {
  if (!pathname) return true;
  const path = pathname.split('?')[0];
  return !TENANT_EXEMPT_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`),
  );
}
